<template>
  <v-btn icon @click="nextTune" :disabled="$store.getters['getSearchInfiniteLoadingFlg']">
    <v-icon>skip_next</v-icon>
  </v-btn>
</template>
<script>
export default {
  name: 'PlayerNextBtn',
  methods: {
    nextTune () {
      this.$store.dispatch('musicPlayerModuleSetNextPlayTuneData')
      if (this.$store.getters.musicPlayerModuleGetIsPlaying) {
        let audio = document.querySelector('#audio')
        const audioPlay = function () {
          audio.play()
        }
        setTimeout(audioPlay, 10)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/PlayerNextBtn.vue